import apiRequest from './wrapper';

/**
 * @method : GET
 * @path   : /skills/
 * @desc   : get skills
 */
export const getSkills = (pathParam, params) => {
  return new Promise((resolve, reject) => {
    apiRequest('get', '/skills/', { params }, pathParam)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          const { status, data } = error.response;
          let errorMessage;

          if (status === 401) {
            // handle unauthorized error
            errorMessage = 'getSkills: You are not authorized to perform this action';
          } else if (status === 404) {
            // handle not found error
            errorMessage = 'getSkills: The resource you are trying to access was not found';
          } else if (status >= 500) {
            // handle server error
            errorMessage = 'getSkills: An error occurred on the server';
          } else {
            errorMessage = data.message;
          }

          reject(new Error(errorMessage));
        } else if (error.request) {
          // The request was made but no response was received
          reject(new Error('getSkills: No response was received from the server'));
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(error);
        }
      });
  });
};

/**
 * @method : GET
 * @path   : /users/me/skills/
 * @desc   : get skill recs
 */
export const getSkillsRecs = (pathParam, params) => {
  return new Promise((resolve, reject) => {
    apiRequest('get', '/users/me/skills/', { params }, pathParam)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          const { status, data } = error.response;
          let errorMessage;

          if (status === 401) {
            // handle unauthorized error
            errorMessage = 'getSkills: You are not authorized to perform this action';
          } else if (status === 404) {
            // handle not found error
            errorMessage = 'getSkills: The resource you are trying to access was not found';
          } else if (status >= 500) {
            // handle server error
            errorMessage = 'getSkills: An error occurred on the server';
          } else {
            errorMessage = data.message;
          }

          reject(new Error(errorMessage));
        } else if (error.request) {
          // The request was made but no response was received
          reject(new Error('getSkills: No response was received from the server'));
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(error);
        }
      });
  });
};

/**
 * @method : PUT
 * @path   : /users/me/skills/{skill_id}
 * @desc   : Update skills rating
 */
export const updateSkillRating = (skill, rating) => {
  return new Promise((resolve, reject) => {
    apiRequest('put', `/users/me/skills/${skill.id}`, { data: { rating } })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          const { status, data } = error.response;
          let errorMessage;

          if (status === 401) {
            // handle unauthorized error
            errorMessage = 'updateSkillsRating: You are not authorized to perform this action';
          } else if (status === 404) {
            // handle not found error
            errorMessage = 'updateSkillsRating: The resource you are trying to access was not found';
          } else if (status >= 500) {
            // handle server error
            errorMessage = 'updateSkillsRating: An error occurred on the server';
          } else {
            errorMessage = data.message;
          }

          reject(new Error(errorMessage));
        } else if (error.request) {
          // The request was made but no response was received
          reject(new Error('updateSkillsRating: No response was received from the server'));
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(error);
        }
      });
  });
};
